<div class="dialog-container">
  <div class="header">
    <h2 class="title">translate</h2>
    <button mat-icon-button (click)="onCloseClick()">
      <mat-icon svgIcon="ak-close"></mat-icon>
    </button>
  </div>
  <mat-dialog-content class="batch-dialog-container">
    <h3 class="title">target languages</h3>
    <app-language-selector
      [selectedLanguages]="selectedLanguages"
      (languageSelectionChanged)="onLanguageSelectionChange($event)"
    ></app-language-selector>
    <div class="notification-box info-notification">
      <mat-icon svgIcon="ak-info-filled" />
      <div class="message">if existing translations aren't empty they won't be overwritten</div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-flat-button (click)="onCloseClick()">close</button>
    <button mat-flat-button (click)="onTranslateClick()" color="primary">translate</button>
  </mat-dialog-actions>
</div>
